<template>
  <div id="record">
    <img src="@/assets/top.png" class="top" />
    <div class="nav">
      <div class="left" @click="toUrl('/venue')">
        <van-icon name="arrow-left" size="20" />
      </div>

      <div class="center">
        预约记录
        <!-- <img src="@/assets/logo.png" width="21" />
        <span style="margin-left:0.3rem">青山湖区智慧残联</span>-->
      </div>
      <div class="right" @click="toHref()">
        <van-icon name="wap-home" size="21" />
      </div>
    </div>
    <div class="padding">
      <div class="feed">
        <div class="feed-tit">
          <div class="time">申请场馆</div>
          <div class="suggest">申请时间</div>
          <div class="state">状态</div>
        </div>
        <van-pull-refresh v-model="isLoading" @refresh="onRefresh" success-text="刷新成功">
          <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
            <div
              class="feed-mian"
              v-for="(item,index) in news"
              :key="index"
              @click="toInfo(item.id)"
            >
              <div class="time">{{item.name}}</div>
              <div class="suggest">{{item.create_time}}</div>
              <div
                :class="{'state':true,'stateJu':item.status==4,'stateTong':item.status==3,'stateDai':item.status==1}"
              >{{item.status_title}}</div>
            </div>
          </van-list>
        </van-pull-refresh>
      </div>
    </div>
  </div>
</template>
<script>
import { Icon, PullRefresh, List } from "vant";
import { reserveList, getTokenByTicket, toknStatus } from "@/api/apiData";
export default {
  components: {
    [Icon.name]: Icon,
    [PullRefresh.name]: PullRefresh,
    [List.name]: List,
  },
  data() {
    return {
      token: "",
      news: [],
      isLoading: false,
      totalPages: 1,
      padding: false,
      loading: false,
      finished: false,
      page: 0,
      chatUrl:"https://qshcjr.ncscloudmedia.com/api.php"
      // chatUrl: "http://cjr.cn/api.php",
    };
  },
  mounted() {
    let ticket = this.$route.query.ticket;
    var token = localStorage.getItem("tokenY");
    // this.token = token;
    // this.getList();
    if (ticket) {
      this.ticket = ticket;
      this.getTokenByTickets();
      this.$router.push("/record");
    } else if (token) {
      this.token = token;
      this.IsTokenStatus(token);
    } else {
      var href = escape(window.location.href);
      var url = this.chatUrl + "/OAuth/wxLogin?url=" + href;
      window.location.href = url;
    }
  },
  methods: {
         // 获取token
    getTokenByTickets() {
      //  alert(this.ticket)
      getTokenByTicket({ ticket: this.ticket }).then((res) => {
        if (res.status == 1) {
          localStorage.setItem("tokenY", res.data.token);
          this.token = res.data.token;
        } else {
          this.$router.push("/record");
          var href = escape(window.location.href);
          var url = this.chatUrl + "/OAuth/wxLogin?url=" + href;
          window.location.href = url;
        }
      });
    },
    // token是否失效
    IsTokenStatus(token) {
      toknStatus({ token: token }).then((res) => {
        if (res.status == 1) {
          this.token = token;
        } else {
          var href = escape(window.location.href);
          var url = this.chatUrl + "/OAuth/wxLogin?url=" + href;
      // alert(url)
          window.location.href = url;
        }
      });
    },
     // 跳转首页
    toHref(){
      window.location.href="http://ncymkj.doudou00.com/index.php?g=Wap&m=Index&a=lists&token=hmatos1596436588&classid=20403"
    },
    toUrl(u) {
      this.$router.push(u);
    },
    // 下拉加载
    onLoad() {
      this.getNewsList();
    },
    // 下拉刷新
    onRefresh() {
      // 清空列表数据
      // 清空列表数据
      var that = this;
      that.news = [];
      that.page = 0;
      that.totalPages = 1;
      that.loading = false;
      that.finished = false;
      that.getNewsList();
      setTimeout(() => {
        that.refreshing = false;
        // Toast("刷新成功");
        that.isLoading = false;
      }, 1500);
    },
    getNewsList() {
      var that = this;
      var news = this.news;
      var page = this.page + 1;
      var totalPages = this.totalPages;
      var param = {
        page: page,
        pageSize: 10,
        token: this.token,
      };
      if (totalPages >= page) {
        reserveList(param).then((res) => {
          //////console.log(res);
          if (res.status == 1) {
            if (res.data.data.length < 4) {
              this.padding = false;
            }
            that.page = page;
            that.news = news.concat(res.data.data);
            that.totalPages = Math.ceil(
              Number(res.data.total) / res.data.data.length
            );
            if (res.data.data.length == 0) {
              //数据请求成功 但是无数据
              that.finished = true;
              that.loading = false;
              return false;
            }
            if (that.news.length >= news.length) {
              // 数据请求成功后  停止加载状态
              setTimeout(() => {
                that.loading = false;
              }, 1500);
            }
          } else {
            //登录失败
            // Toast(res.message);
            this.onRefresh()
          }
        });
      } else {
        // 全部数据加载完毕
        that.finished = true;
      }
    },
    toInfo(id) {
      this.$router.push({
        path: "/recordInfo",
        query: {
          id: id,
        },
      });
    },
  },
};
</script>
<style scoped>
.feed-tit {
  display: flex;
  /* background: #f5f5f5; */
  line-height: 2.5rem;
  font-size: 0.9rem;
  border-top: solid 1px #d2d2d2;
  border-bottom: solid 1px #d2d2d2;
  padding: 0 1rem;
  font-weight: bold;
  /* position: fixed;
    width: 100%; */
}
/* .feed-mian:nth-child(1){
  padding-top: 3.5rem;
} */
.feed-mian {
  display: flex;
  font-size: 0.8rem;
  padding: 1rem;
  background: white;
  border-bottom: solid 1px #d2d2d2;
}
.time {
  width: 40%;
  /* text-align: left; */
}
.state {
  width: 30%;
  text-align: center;
}
.suggest {
  width: 40%;
  padding: 0 5%;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  /* text-align: left; */
}
.feed-tit .time,
.feed-tit .suggest {
  text-align: center;
}
.feed-mian .suggest {
  color: #b1b1b1;
}
.feed-mian .state {
  color: grey;
}
.stateJu {
  color: red !important;
}
.stateTong {
  color: green !important;
}
.stateDai {
  color: #ff5722 !important;
}
</style>


// WEBPACK FOOTER //
// src/page/record.vue